<template>
  <div class="lg-aa-barra-pesquisa">
    <div class="lg-aa-barra-pesquisa__container p-fluid">
      <PAutoComplete
        ref="autocomplete"
        v-model="model"
        :suggestions="sugestoes"
        option-group-label="grupo"
        option-group-children="itens"
        :min-length="2"
        :placeholder="$t_v2('8414', 'Pesquisar por...')"
        :aria-label="
          $t_v2('46302', 'Informe 2 ou mais caracteres para pesquisar')
        "
        :title="$t_v2('46302', 'Informe 2 ou mais caracteres para pesquisar')"
        scroll-height="300px"
        field="titulo"
        class="w-100"
        autofocus="true"
        panel-class="lg-aa-barra-pesquisa__container__autocomplete"
        @complete="efetuarPesquisa($event)"
        @focus="focarElementoPesquisa"
        @blur="limparPesquisa"
        @item-select="selecionarItemPesquisado($event)"
      >
        <template #optiongroup="slotProps">
          <div class="p-d-flex p-ai-center">
            <span class="p-ml-2 lg-aa-font-size--18">
              {{ slotProps.item.grupo }}
            </span>
          </div>
        </template>

        <template #item="{ item }">
          <div v-if="item.grupo" class="lg-aa-barra-pesquisa__grupo">
            {{ item.titulo }}
          </div>
          <component :is="`Tipo${item.tipo}`" :model="item" />
        </template>
      </PAutoComplete>
      <i
        :aria-label="$t_v2('8414', 'Pesquisar por...')"
        role="img"
        class="pi pi-search lg-aa-barra-pesquisa__search"
      />
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div
          v-if="!mobile && showShortcut && !isIE"
          class="lg-aa-barra-pesquisa__shortcut p-d-none p-d-sm-block"
          aria-label="CTRL + SHIFT + F"
        >
          <span>CTRL</span> + <span>SHIFT</span> +
          <span>F</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import PAutoComplete from 'primevue/autocomplete';

import Servico from 'lg-vue-components/barraPesquisa/components/servico';
import Colaborador from 'lg-vue-components/barraPesquisa/components/colaborador';
import Noticia from 'lg-vue-components/barraPesquisa/components/noticia';

import { isIEBrowser } from 'lg-vue-components/utils';

const DEFAULT_MODEL = {
  titulo: '',
};

export default {
  name: 'LGBarraPesquisa',
  components: {
    PAutoComplete,
    Tipo0: Servico,
    Tipo1: Colaborador,
    Tipo2: Noticia,
  },
  props: {
    itensPesquisados: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'pesquisar',
    'pesquisar-change',
  ],
  data() {
    return {
      timeout: 0,
      showShortcut: true,
      model: { ...DEFAULT_MODEL },
    };
  },
  computed: {
    isIE() {
      return isIEBrowser();
    },
    nomeRota() {
      return this.$route.name;
    },
    sugestoes() {
      const resultado = this.itensPesquisados || [];
      const lista = [];

      resultado.forEach((item) => {
        const obj = {
          grupo: '',
          itens: [],
        };

        obj.grupo = item.grupo;

        item.itens.forEach((itemPesquisa) => {
          obj.itens.push({
            ...itemPesquisa,
            rota: itemPesquisa.rota || item.rota,
          });
        });

        lista.push(obj);
      });

      return lista;
    },
  },
  watch: {
    nomeRota(nome) {
      if (nome === 'home') {
        this.$refs.autocomplete.focus();
      }
    },
  },
  mounted() {
    const { selectItem } = this.$refs.autocomplete;

    this.$refs.autocomplete.selectItem = (event, item) => {
      if (!item.grupo) {
        selectItem(event, item);
      }
    };

    this.inicializeShortcut();

    this.$refs.autocomplete.focus();
  },
  methods: {
    inicializeShortcut() {
      if (!this.mobile && !this.isIE) {
        document.addEventListener('keyup', (evt) => {
          try {
            if (evt.ctrlKey && evt.shiftKey && evt.key.toUpperCase() === 'F') {
              this.$refs.autocomplete.focus();
            }
          } catch {
            /* ignore o erro */
          }
        }, false);
      }
    },
    efetuarPesquisa(termo) {
      if (termo.query.length >= 2) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$emit('pesquisar', termo.query);
        }, 400);
      }
    },
    selecionarItemPesquisado() {
      this.$emit('pesquisar-change', this.model);
      this.limparPesquisa();
    },
    limparPesquisa() {
      this.showShortcut = true;
      this.model = { ...DEFAULT_MODEL };
    },
    focarElementoPesquisa() {
      this.showShortcut = false;
    },
  },
};
</script>
